import { CALENDAR_GRID_WEEK_COLUMN_SKELETON_ROWS } from './CalendarGridWeekColumnSkeleton.constants'

export function getCalendarGridWeekColumnSkeletonStyle(dayIndex) {
  return {
    '--calendar-grid-block-start': String(
      CALENDAR_GRID_WEEK_COLUMN_SKELETON_ROWS[
        dayIndex % CALENDAR_GRID_WEEK_COLUMN_SKELETON_ROWS.length
      ]
    ),
  }
}
